import React from "react";
import PropTypes from "prop-types";

import GroupListLoader from "components/Loaders/GroupsList";
import { groupTypes } from "domain/Groups/types";
import InvitationsModalGroupListItem from "components/GameInvitations/Modal/GroupList/Item";
import { useDispatch, useSelector } from "react-redux";
import { toArray } from "lib/converters";
import { inviteGroup } from "domain/Game/api";
import { updateGameData as updateGameDataForList } from "domain/GamesSearch/actions";
import { updateGameData as updateGameDataForPage } from "domain/Game/actions";
import { updateGameData as updateRegularGame } from "domain/RegularGames/actions";

const InvitationsModalGroupList = (props) => {
    const {
        invitedGroups,
        gameId,
        toggleModal,
        isInvate = true,
        isRegular = false,
    } = props;
    const groups = useSelector((state) => state?.GROUPS?.groups);

    const dispatch = useDispatch();

    const updateGameData = (res) => {
        if (!isRegular) {
            dispatch(updateGameDataForList(gameId, res));
            dispatch(updateGameDataForPage(gameId, res));
            return;
        }
        dispatch(updateRegularGame(gameId, res));
    };

    const handleClickItem = async (group) => {
        const res = await inviteGroup(
            gameId,
            group.id,
            isRegular ? "regular_games" : "games",
            isInvate
        );
        updateGameData(isRegular ? res?.regular_game : res?.game);
        toggleModal();
    };

    return (
        <div className="players-list players-list_no-gap players-list--modal">
            <div className="players-list__title">Списки</div>

            <GroupListLoader>
                {toArray(groups)?.map((group, key) => {
                    return (
                        <InvitationsModalGroupListItem
                            key={key}
                            gameId={gameId}
                            group={group}
                            invited={Boolean(
                                invitedGroups?.find(({ id }) => group.id === id)
                            )}
                            textButton={!isInvate ? "Добавить" : "Пригласить"}
                            activeTextButton={
                                !isInvate ? "Добавлена" : "Отправлено"
                            }
                            handleClickItem={!isInvate ? handleClickItem : null}
                            updateGameData={updateGameData}
                        />
                    );
                })}
            </GroupListLoader>
        </div>
    );
};

InvitationsModalGroupList.defaultProps = {
    groups: [],
    invitedGroups: [],
};

InvitationsModalGroupList.propTypes = {
    gameId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    groups: PropTypes.arrayOf(groupTypes),
    invitedGroups: PropTypes.array,
    toggleModal: PropTypes.func,
    isInvate: PropTypes.bool,
    isRegular: PropTypes.bool,
};

export default InvitationsModalGroupList;
